import { useEffect, useState } from 'react';
import { Button, Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import WarningIcon from '@mui/icons-material/Warning';
import { Trans, useTranslation } from 'react-i18next';

function DialogConfirmationSubmitEA(props) {
    const { t } = useTranslation();
    return (
        <Dialog open={props.open}
            maxWidth={'sm'} fullWidth>
            <DialogTitle style={{ fontSize: 20, paddingBottom: 8, paddingTop: 8, backgroundColor: '#FFD500', color: '#FFF' }}>
                <Grid container direction="row">
                    <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                        <WarningIcon style={{ fontSize: 20 }} />
                        &nbsp;&nbsp;{t('dialog.submitTitle')}
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent style={{ paddingBottom: 5, paddingTop: 5 }}>
                <Grid container direction="row" alignItems="stretch" spacing={1} >
                    <Grid item xs={12}>
                        <span style={{ fontSize: 18 }}>{t('dialog.textSubmit')}</span>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ justifyContent: "flex-start", paddingLeft: 24, paddingBottom: 16 }}>
                <Button variant="contained"
                    onClick={props.onConfirm}
                    style={{ minWidth: 100 }}>
                    <Trans>button.confirm</Trans>
                </Button>
                <Button variant="contained"
                    color="warning"
                    style={{ minWidth: 100 }}
                    onClick={props.onClose}>
                    <Trans>button.cancel</Trans>
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DialogConfirmationSubmitEA;
